import * as breakpoint from '@pixelunion/breakpoint';
import EventHandler from '@pixelunion/events';
import Parallax from '../components/Parallax';

export default class DynamicImageBlock {
  constructor(section) {
    this.el = section.el;
    this.settings = section.data;
    this.parallax = this.settings.parallax;
    this.events = new EventHandler();
    this.imageEl = this.el.querySelector('img, svg');
    this.pictureEl = this.el.querySelector('.picture-block-image');
    this.imageHeight = this.imageEl.offsetHeight;
    this.contentHeight = this.el.querySelector('.picture-block-wrapper').offsetHeight;
    this.fixedHeightMobile = this.settings.fixedHeightMobile;
    this.fixedHeightDesktop = this.settings.fixedHeightDesktop;

    if (this.contentHeight > this.imageHeight) {
      this.pictureEl.classList.add('picture-block-image--extended');
    }

    this.parallaxObject = null;

    if (this.parallax) {
      this.parallaxObject = new Parallax({
        img: this.imageEl,
        container: this.pictureEl,
        isVisible: () => true,
      });

      const isNotFixed = (breakpoint.max('M') && !this.fixedHeightMobile)
      || (breakpoint.min('L') && !this.fixedHeightDesktop);

      if (isNotFixed) {
        if (this.imageEl.clientHeight > 0) {
          this._setPictureHeight();
        } else {
          this.events.register(this.imageEl, 'load', () => this._setPictureHeight());
        }
      }

      this.events.register(window, 'resize', () => {
        if (isNotFixed) {
          this._setPictureHeight();
        } else {
          this.pictureEl.style.height = '';
        }
      });
    }
  }

  _setPictureHeight() {
    this.pictureEl.style.height = `${this.imageEl.clientHeight}px`;
  }

  onSectionUnload() {
    if (this.parallax) {
      this.parallaxObject.unload();
      this.parallaxObject = null;
      this.events.unregisterAll();
    }
  }
}
